<template>
  <div
    class="status-prod"
    :class="{produzindo: validaProd(status), parada: validaParada(status), ociosa: validaOciosa(status), setup: validaSetup(status)}"
  >
    <div class="tag">
      <p>{{ status }}</p>
      <span v-if="status === 'Produção'">{{ atraso > 0 ? "+" + atraso : atraso }}</span>
      <font-awesome-icon
        class="arrow"
        icon="chevron-circle-up"
        v-if="(status === 'Produção') && (atraso >= 0)"
      />
      <font-awesome-icon
        v-if="(status === 'Produção') && (atraso < 0)"
        class="arrow arrow-down"
        icon="chevron-circle-up"
      />
    </div>
    <div class="status-prod-progress-bar">
      <ProgressBar :progress="progress" :total="total" :extra="extra" v-if="status === 'Produção'"></ProgressBar>
      <div class="tag" v-if="status !== 'Produção'">
        <p>{{ motivo }}</p>
        <span>{{ tempoEstado }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import ProgressBar from "./ProgressBar";

export default {
  name: "StatusProd",
  props: {
    status: String,
    atraso: Number,
    motivo: String,
    progress: Number,
    total: Number,
    tempoEstado: String,
    extra: String
  },
  components: {
    ProgressBar
  },
  methods: {
    validaProd(p) {
      let result = false;
      if (p === "Produção") result = true;

      return result;
    },
    validaParada(p) {
      let result = false;
      if (p === "Parada") result = true;

      return result;
    },
    validaOciosa(p) {
      let result = false;
      if (p === "Ocioso") result = true;

      return result;
    },
    validaSetup(p) {
      let result = false;
      if (p === "Setup") result = true;

      return result;
    }
  }
};
</script>

<style scoped>
.status-prod {
  height: 100%;
  display: flex;
  padding: 0 4rem;
  align-items: center;
  font-size: 1em;
  justify-content: space-between;
  background-size: 140%;
  background-position: 50%, 50%;
}

.produzindo {
  background-image: linear-gradient(135deg, #388e3c, transparent 44%);
  background-image: linear-gradient(
    135deg,
    var(--color-success),
    transparent 44%
  );
}

.parada {
  background-image: linear-gradient(135deg, #b71c1c, transparent 44%);
  background-image: linear-gradient(135deg, var(--color-stop), transparent 44%);
}

.ociosa {
  background-image: linear-gradient(135deg, #1e88e5, transparent 44%);
  background-image: linear-gradient(
    135deg,
    var(--color-danger),
    transparent 44%
  );
}

.setup {
  background-image: linear-gradient(135deg, #20c997, transparent 44%);
  background-image: linear-gradient(
    135deg,
    var(--color-setup),
    transparent 44%
  );
}

.tag {
  flex-basis: 33%;
  text-align: center;
}

.status-prod-progress-bar {
  flex-basis: 62%;
}

.arrow {
  color: #388e3c;
  color: var(--color-success);
  font-size: 0.8em;
}

.arrow-down {
  transform: rotate(180deg);
  color: #b71c1c;
  color: var(--color-stop);
}
</style>
